<template>
  <div>
    <slideout-panel />
    <h1 class="page-title"><i class="fal fa-cogs"></i> Systeminställningar</h1>
    <div class="columns">
      <div class="column">
        <h4 style="text-decoration: underline">Generellt för email</h4>
        <div class="columns">
          <div class="column is-half">
            <label class="label">Avsändaremail</label>
            <input class="input" type="email" v-model="systemSettings.emailFrom">
          </div>
          <div class="column is-half">
            <label class="label">Avsändarnamn</label>
            <input class="input" type="text" v-model="systemSettings.emailFromName">
          </div>
        </div>
      </div>

      <div class="column">
        <h4 style="text-decoration: underline">Fakturamail</h4>
        <div class="columns">
          <div class="column is-half">
            <label class="label">Mottagare</label>
            <input class="input" type="email" v-model="systemSettings.invoiceEmailTo">
          </div>
          <div class="column is-half">
            <label class="label">BCC</label>
            <input class="input" type="email" v-model="systemSettings.invoiceEmailToBcc">
          </div>
        </div>
      </div>
    </div>

    <h4 style="text-decoration: underline">SendGrid</h4>
    <div class="columns">
      <div class="column is-half">
        <label class="label">API-nyckel</label>
        <input class="input" v-model="systemSettings.sendGridApiKey">
      </div>
    </div>

    <h4 style="text-decoration: underline">Fortnox</h4>
    <div class="columns">

      <div class="column one-quarter">
        <label class="label">Authorization code</label>
        <input class="input" v-model="systemSettings.fortnoxAuthorizationCode">
      </div>

      <div class="column one-quarter">
        <label class="label">Client secret</label>
        <input class="input" v-model="systemSettings.fortnoxClientSecret">
      </div>

      <div class="column one-quarter">
        <label class="label">Access token</label>
        <input class="input" v-model="systemSettings.fortnoxAccessToken" :disabled="!accessTokenEnabled">
      </div>

      <div class="column one-quarter">
        <label class="label">&nbsp;</label>
        <button class="button" @click="accessTokenEnabled = !accessTokenEnabled"><i class="fal" :class="getAccessTokenIcon()" style="width: 1.2rem"></i></button>
      </div>
    </div>

    <button class="button is-success" @click="save" :disabled="saving">Spara</button>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      systemSettings: {},
      accessTokenEnabled: false
    }
  },
  computed: {
    ...mapState({
      settings: state => state.systemSettings.all.settings,
      saving: state => state.systemSettings.all.saving
    })
  },
  methods: {
    ...mapActions('systemSettings', ['getSystemSettings', 'saveSystemSettings']),
    getAccessTokenIcon () {
      if (this.accessTokenEnabled) {
        return 'fa-lock-open-alt'
      } else {
        return 'fa-lock-alt'
      }
    },
    save () {
      this.saveSystemSettings(this.systemSettings)
    }
  },
  created () {
    this.getSystemSettings().then(systemSettings => {
      this.systemSettings = systemSettings
    })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Settings/SystemSettingsPage.vue